<template>
    <div>
        <button class="view-360" style="border: none; background: none" @click.prevent="openModal()">
            <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.374 20.2698C17.2003 20.2698 0 20.1119 0 14.4784C0 12.8207 1.74464 11.3815 5.04715 10.3159C5.42648 10.1914 5.83477 10.4028 5.95783 10.7821C6.0809 11.1615 5.87386 11.5697 5.49163 11.6928C2.50909 12.6556 1.44783 13.7632 1.44783 14.4784C1.44783 17.17 10.7241 18.8219 17.374 18.8219C23.09 18.8219 33.3002 17.3712 33.3002 14.4784C33.3002 13.5808 31.861 12.5601 29.4504 11.7478C29.071 11.6204 28.8683 11.2092 28.9958 10.8313C29.1232 10.4535 29.5358 10.2464 29.9122 10.3767C33.9097 11.7218 34.748 13.3506 34.748 14.4784C34.748 20.1119 17.5477 20.2698 17.374 20.2698Z" fill="#4063BF"/>
                <path d="M17.374 34.7478C8.95195 34.7478 0 32.718 0 28.9565V14.4782C0 14.0786 0.324315 13.7543 0.723916 13.7543C1.12352 13.7543 1.44783 14.0786 1.44783 14.4782V28.9565C1.44783 30.7706 7.50701 33.3 17.374 33.3C27.241 33.3 33.3002 30.7706 33.3002 28.9565V14.4782C33.3002 14.0786 33.6245 13.7543 34.0241 13.7543C34.4237 13.7543 34.748 14.0786 34.748 14.4782V28.9565C34.748 32.718 25.796 34.7478 17.374 34.7478Z" fill="#4063BF"/>
                <path d="M5.22693 33.1408C5.04016 33.1408 4.85483 33.0698 4.71295 32.9265C4.43207 32.6427 4.43496 32.1837 4.71729 31.9029L9.7543 26.9078C10.5159 26.1477 11.7089 26.1492 12.4704 26.9093L15.3545 29.6631C15.4646 29.7731 15.6006 29.8383 15.6904 29.8238C15.8149 29.8223 15.9365 29.763 16.0437 29.6529L20.3104 25.224C21.0865 24.4494 22.2346 24.4103 22.9947 25.1285L30.1572 31.4381C30.4583 31.7016 30.4873 32.1606 30.2223 32.4603C29.9588 32.76 29.4998 32.7904 29.2016 32.524L22.0203 26.197C21.7728 25.9697 21.5136 26.0696 21.3442 26.2375L17.0847 30.6592C16.7025 31.0501 16.2116 31.2658 15.7005 31.2702C15.1388 31.2846 14.7131 31.0704 14.3425 30.6968L11.4584 27.943C11.2427 27.7259 10.9792 27.7302 10.7765 27.9315L5.73801 32.9294C5.59612 33.0713 5.4108 33.1408 5.22693 33.1408Z" fill="#4063BF"/>
                <path d="M15.202 26.061C14.0047 26.061 13.0303 25.0866 13.0303 23.8892C13.0303 22.6919 14.0047 21.7175 15.202 21.7175C16.3994 21.7175 17.3738 22.6919 17.3738 23.8892C17.3738 25.0866 16.3994 26.061 15.202 26.061ZM15.202 23.1653C14.8039 23.1653 14.4781 23.4896 14.4781 23.8892C14.4781 24.2888 14.8039 24.6131 15.202 24.6131C15.6002 24.6131 15.9259 24.2888 15.9259 23.8892C15.9259 23.4896 15.6002 23.1653 15.202 23.1653Z" fill="#4063BF"/>
                <path d="M28.2327 19.039C27.8331 19.039 27.5088 18.7147 27.5088 18.3151V15.1154C27.5088 14.7158 27.8331 14.3915 28.2327 14.3915C28.6323 14.3915 28.9566 14.7158 28.9566 15.1154V18.3151C28.9566 18.7147 28.6323 19.039 28.2327 19.039Z" fill="#4063BF"/>
                <path d="M6.51493 19.0389C6.11533 19.0389 5.79102 18.7146 5.79102 18.315V15.5351C5.79102 15.1355 6.11533 14.8112 6.51493 14.8112C6.91453 14.8112 7.23885 15.1355 7.23885 15.5351V18.315C7.23885 18.7146 6.91453 19.0389 6.51493 19.0389Z" fill="#4063BF"/>
                <path d="M18.0981 13.0305H15.9263C15.1271 13.0305 14.4785 12.3804 14.4785 11.5827V5.79134C14.4785 4.99358 15.1271 4.34351 15.9263 4.34351H18.822C19.2216 4.34351 19.5459 4.66782 19.5459 5.06742C19.5459 5.46702 19.2216 5.79134 18.822 5.79134H15.9263V7.96309H18.0981C18.8973 7.96309 19.5459 8.61317 19.5459 9.41092V11.5827C19.5459 12.3804 18.8973 13.0305 18.0981 13.0305ZM15.9263 9.41092V11.5827H18.0981V9.41092H15.9263Z" fill="#4063BF"/>
                <path d="M24.6128 13.0305H22.441C21.6418 13.0305 20.9932 12.3804 20.9932 11.5827V5.79134C20.9932 4.99358 21.6418 4.34351 22.441 4.34351H24.6128C25.412 4.34351 26.0606 4.99358 26.0606 5.79134V11.5827C26.0606 12.3804 25.412 13.0305 24.6128 13.0305ZM21.7171 11.5827L22.441 11.5841V11.5827H21.7171ZM22.441 11.5827H24.6128V5.79134H22.441V11.5827Z" fill="#4063BF"/>
                <path d="M11.5822 13.0306H9.41044C9.01084 13.0306 8.68652 12.7063 8.68652 12.3067C8.68652 11.9071 9.01084 11.5828 9.41044 11.5828H11.5822V9.41104H9.41044C9.01084 9.41104 8.68652 9.08672 8.68652 8.68712C8.68652 8.28752 9.01084 7.9632 9.41044 7.9632H11.5822C12.3814 7.9632 13.03 8.61328 13.03 9.41104V11.5828C13.03 12.3805 12.3814 13.0306 11.5822 13.0306Z" fill="#4063BF"/>
                <path d="M11.5822 9.41092H9.41044C9.01084 9.41092 8.68652 9.08661 8.68652 8.687C8.68652 8.2874 9.01084 7.96309 9.41044 7.96309H11.5822V5.79134H9.41044C9.01084 5.79134 8.68652 5.46702 8.68652 5.06742C8.68652 4.66782 9.01084 4.34351 9.41044 4.34351H11.5822C12.3814 4.34351 13.03 4.99358 13.03 5.79134V7.96309C13.03 8.76084 12.3814 9.41092 11.5822 9.41092Z" fill="#4063BF"/>
                <path d="M29.6805 4.3435C28.4832 4.3435 27.5088 3.36911 27.5088 2.17175C27.5088 0.974392 28.4832 0 29.6805 0C30.8779 0 31.8523 0.974392 31.8523 2.17175C31.8523 3.36911 30.8779 4.3435 29.6805 4.3435ZM29.6805 1.44783C29.2824 1.44783 28.9566 1.77215 28.9566 2.17175C28.9566 2.57135 29.2824 2.89567 29.6805 2.89567C30.0787 2.89567 30.4045 2.57135 30.4045 2.17175C30.4045 1.77215 30.0787 1.44783 29.6805 1.44783Z" fill="#4063BF"/>
            </svg>
        </button>
        <div class="modal fade" id="modal360View" tabindex="-1" aria-labelledby="modal360ViewLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-body p-5">
                        <div v-if="loading" class="loader">
                            <h4 class="text-center my-3">Loading...</h4>
                        </div>
                        <div class="image-container" @mousedown="startMoving" @touchstart="startMoving" @mousemove="move" @touchmove="move" @mouseup="stopMoving" @toucjend="stopMoving">
                            <img
                                v-for="i in 36"
                                v-show="currentIndex === (i)"
                                :key="i" :src="imageUrl(i)"
                                @load="imagesLoaded++"
                                :alt="i" draggable="false"
                            >
                        </div>
                        <div class="manual-moving">
                            <i class="bi bi-arrow-left" @click="moveLeft"></i>
                            <i class="bi bi-arrow-right" @click="moveRight"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: "View360",
    data() {
        return {
            loading: true,
            currentIndex: 1,
            x: null,
            imagesLoaded: 0
        }
    },
    watch: {
        imagesLoaded(newVal) {
            this.loading = (newVal < 36);
        }
    },
    methods: {
        imageUrl(index) {
            return '/assets/images/360/'+ String(index).padStart(2, '0') +'.jpg';
        },
        openModal() {
            let modal = new bootstrap.Modal(document.getElementById('modal360View'))
            modal.show();
        },
        moveLeft() {
            this.currentIndex = this.currentIndex !== 36 ? this.currentIndex+1 : 1;
        },
        moveRight() {
            this.currentIndex = this.currentIndex !== 1 ? this.currentIndex-1 : 36;
        },
        startMoving(e) {
            this.x = e.clientX;
        },
        stopMoving(e) {
            this.x = null;
        },
        move(e) {
            e.preventDefault();
            if (this.x) {
                if (e.clientX < this.x - 10) {
                    this.x = e.clientX
                    this.moveLeft();
                }
                if (e.clientX > this.x + 10) {
                    this.x = e.clientX
                    this.moveRight();
                }
            }
        }
    }
}
</script>

<style scoped>

</style>
